import { WithTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import {
  destroy,
  getFormAsyncErrors,
  isAsyncValidating,
  isDirty,
  isSubmitting,
  submit,
} from 'redux-form'
import { toggleCreateReservationModal } from '../../../actions/bookingCalendar/reservationModal/toggleReservationModal'
import { ToggleCreateModal } from '../../../actions/bookingCalendar/reservationModal/toggleConfigurationModal'
import { IStore } from '../../../reducers'
import {
  getModalCreateReservationIsOpen,
  getModalReservationIsLoading,
  getModalReservationIsSaving,
} from '../../../reducers/bookingCalendar/selectors/getModalOpen'
import { FormNames } from '../../Form/CreateReservation'
import { toggleCloseModal } from '../../../actions/bookingCalendar/reservationModal/toggleCloseModal'
import fireToastError from '../../../actions/toasts/fireToastError'
import selectReservationTab from '../../../actions/bookingCalendar/reservationModal/selectReservationTab'
import openModal from '../../../actions/Modals/openModal'
import closeModal from '../../../actions/Modals/closeModal'
import {
  IReservationModalDispatch,
  IReservationModalProps,
} from './ReservationModal'
import { Mixpanel } from '../../../utils/Mixpanel'
import { getModalIsHidden } from '../../../reducers/modals/selectors/getModals'
import { PermissionScope } from '../../Employees'
import { isInScope } from '../../../hooks/useIsScope'

const mapStateToProps = () => {
  return (state: IStore): IReservationModalProps => {
    const scope = isInScope(state)
    return {
      errors: getFormAsyncErrors('create_reservation')(state),
      isDirty: isDirty(FormNames.Create)(state),
      isLoading: getModalReservationIsLoading(state),
      isSaving: getModalReservationIsSaving(state),
      isSubmitting: isSubmitting(FormNames.Create)(state),
      isValidating: isAsyncValidating(FormNames.Create)(state),
      hideModal: getModalIsHidden(state),
      open: getModalCreateReservationIsOpen(state),
      type: 'create',
      allowReservationEdit: scope([
        PermissionScope.SCOPE_CAN_EDIT_RESERVATIONS,
      ]),
    }
  }
}

const bindDispatchToProps = (
  dispatch: Dispatch,
  ownProps: any,
): IReservationModalDispatch => ({
  fireError: (message, id) => {
    dispatch(fireToastError(message, null, 'Event', id))
    dispatch(selectReservationTab(0))
  },
  modalClose(id) {
    dispatch(closeModal(id))
  },
  modalOpen(id, element) {
    dispatch(openModal(id, element))
  },
  onClose() {
    Mixpanel.people.increment(ownProps.userId, 'New Reservation Abandoned', 1)
    Mixpanel.track('New Reservation Abandoned', {
      'Tabs Form View?': true,
    })
    dispatch(toggleCreateReservationModal(false))
    dispatch(destroy(FormNames.Create))
  },
  submitForm: () => {
    dispatch(submit(FormNames.Create))
  },
  toggleCloseModal() {
    dispatch(toggleCloseModal(true))
  },
  toggleConfigurationModal() {
    dispatch(ToggleCreateModal())
  },
})

export default connect<
  IReservationModalProps,
  IReservationModalDispatch,
  WithTranslation
>(
  mapStateToProps(),
  bindDispatchToProps,
)
